var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolBookmarkSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.72168V14.3584C14.4997 15.2278 13.3699 15.8847 12.4834 15.2568L8.88379 12.707C7.91297 12.0195 6.58703 12.0195 5.61621 12.707L2.0166 15.2568C1.13005 15.8847 0.000290751 15.2278 0 14.3584V4.72168H14.5ZM13.25 0C13.9815 0 14.5 0.549842 14.5 1.13867V3.22168H0V1.13867C0 0.549842 0.518531 0 1.25 0H13.25Z",
    fill: "#5767DB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolBookmarkSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_bookmark_selected.a49f7f75915e7f501d022145c1a69c58.svg";